import { useScript } from '@clover-util/script-registry';
import { isCloverProdEnvironment } from 'util/Environment';

export const GOOGLE_API_KEY = isCloverProdEnvironment()
? 'AIzaSyDPNoFNXEyPFfVPcq5w1DwFRJvvprMA3kE'
: 'AIzaSyBFw89v5kSlXVLcvZJ3J0xKHScpW0WqcAY';
const BASE_URL = 'https://maps.googleapis.com/maps/api/js';
const PARAMS = new URLSearchParams({ key: GOOGLE_API_KEY, libraries: 'places' });

export const useGoogleMapsScript = () => {

  const [googleMapsLoaded, googleMapsError] = useScript(`${BASE_URL}?${PARAMS.toString()}`);

  return {
    googleMapsLoaded,
    googleMapsError,
  };
};
